import { Autocomplete, Box, Button, Drawer, FormControlLabel, Checkbox, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { CommonGridToolBarWithFilterTextCustom} from "../../../../Components/Common Components/CommonComponents";
import '../../../FrontOffice/FOReports/reports.css';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { AmountFormat, formatDate} from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

class CreditSettlementPharmacyReport extends Component {

    constructor(props) {
        super(props)
        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
        let isNewBilling = (localGetItem("isNewBilling") === "true") ? true : false;
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            appointmentType: [],
            dateIndex: 1,
            creditAdjustedData: [],
            appointmentTypeCardList: [],
            totalAppointment: null,
            totalAmount: null,
            appointmentTypeList: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            timeError: false,
            creditType: [],
            opSelected: true,
            ipSelected: true,
            labSelected: isNewBilling ? false : true,
            pharmacySelected: true,
            OtSelected: isNewBilling ? false : true,
            RadiologySelected: (!isNewBilling && localGetItem("Show_Radiology_Bills_In_FO") === "true" ) ? true : false,
            PharmacyData: [],
            LabData: [],
            patient_name : "",
            uhid : "",
        }
    }

    componentDidMount() {
        this.getCreditAdjustedData() 
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

    getCreditAdjustedData = () => {
        try {
            let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
            let PharmacyId = LoggedData.pharmacy_id
            let moduleType = ["pharmacy"]
            this.LoaderFunction(true)
            var { FilterDatas } = this.state
            RestAPIService.getAll((localGetItem('isNewBilling') === "true" ? Serviceurls.NEW_CREDIT_ADJUSTMENT_REPORT : Serviceurls.FO_REPORT_CREDIT_ADJUSTED_REPORTS) + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&credit_type=${this.state.creditType ? this.state.creditType : ''}&module_type=${moduleType}&laboratory_id=${null}&pharmacy_id=${PharmacyId}&clinic_id=${LoggedData?.clinic_id}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid :""}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            creditAdjustedData: response.data.data,
                            totalAmount: response.data.bill_amount,
                            receiptAmount: response.data.receipt_amount,
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,

                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }
    printReports = () => {
        try {
            let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
            let PharmacyId = LoggedData.pharmacy_id
            let moduleType = ["pharmacy"]
            var { FilterDatas } = this.state
            RestAPIService.getAllTwo((localGetItem('isNewBilling') === "true" ? Serviceurls.NEW_CREDIT_ADJUSTMENT_REPORT : Serviceurls.FO_REPORT_CREDIT_ADJUSTED_REPORTS)  + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&clinic_id=${LoggedData?.clinic_id}&credit_type=${this.state.creditType ? this.state.creditType : ''}&module_type=${moduleType}&laboratory_id=${null}&pharmacy_id=${PharmacyId}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid :""}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    handleCheckBox = (e, data) => {
        let states = this.state
        data["isChecked"] = e.target.checked
        this.setState({ states })
    }

    renderFilterScreen = () => {
        const { t } = this.props
        let CreditTypeList = [{
            label: (localGetItem('isNewBilling') === "true") ?  'Corporate credit' :"Corporate credit",
            value: "Corporate credit"
        }, {
            label: "Patient credit",
            value: "Patient credit"
        }, {
            label: "Insurance credit",
            value: "Insurance credit"
        }]
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true}/>
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={CreditTypeList.map((item) => (item.value))}
                            getOptionLabel={(option) => (option)}
                            value={this.state.creditType}
                            onChange={(event, newValue) => {
                                this.setState({ creditType: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Credit Type')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'patient_name' }}
                            size='small'
                            label={t("Patient Name")}
                            value={this.state.patient_name}
                            autoComplete='off'
                            emed_tid={"patient_nameTestID01"}
                            onChange={(e) => {
                                let alpha = CommonValidation.alphabetOnly(e.target.value);
                                if (alpha || e.target.value === "") {
                                    this.setState({ patient_name: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'UHID' }}
                            size='small'
                            label={t("UHID")}
                            value={this.state.uhid ? this.state.uhid : ""}
                            autoComplete='off'
                            emed_tid={"UHIDTestID01"}
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e?.target?.value === "") {
                                    this.setState({ uhid: e.target.value })
                                }
                            }}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                creditType: [],
                                optionType: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false
                                },
                                timeError: false,
                                opSelected: true,
                                ipSelected: true,
                                labSelected: true,
                                pharmacySelected: true,
                                patient_name : "",
                                uhid : "",
                                OtSelected: true,
                                RadiologySelected: localGetItem("Show_Radiology_Bills_In_FO") === "true",
                            }, () => this.getCreditAdjustedData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false}
                        onClick={() => {
                            this.getCreditAdjustedData()
                            this.setState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }
    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]

        var ExportData = [];
            this.state.creditAdjustedData?.length > 0 && this.state.creditAdjustedData.map((item) => {
                const data = {
                    "Patient Name": item?.patient_name,
                    "UHID": item?.patient_uhid,
                    "Bill No": item.invoice_number,
                    "Bill date": item.invoice_date,
                    "Bill Amount": item.net_amount,
                    "Credit type": item.credit_type,
                    "Receipt No": item.receipt_number,
                    "Receipt Date": item.receipt_date,
                    "Receipt Amount":  item.receipt_amount || 0,
                };
                ExportData.push(data);
            });
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Credit Settlement Report"} FilterTextArray={TextArray} filename={"Credit Settlement Report"} />
            </Box>

        )
    }
    render() {
        this.state.creditAdjustedData.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "patient_name", headerName: t("Patient Name"), flex: 0.111, density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.patient_name?.length > 14 ?
                    <Tooltip placement='top' title={row?.patient_name} arrow><div>{row?.patient_name.slice(0, 12) + "..."}</div></Tooltip>
                    : row?.patient_name ? row?.patient_name : "-"}</Box>)
            },
            {
                field: "patient_uhid", headerName: t("UHID"), flex: 0.111, density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.patient_uhid?.length > 20 ?
                    <Tooltip placement='top' title={row?.patient_uhid} arrow><div>{row?.patient_uhid.slice(0, 18) + "..."}</div></Tooltip>
                    : row?.patient_uhid ? row?.patient_uhid : "-"}</Box>)
            },
            {
                field: "invoice_number", headerName: t("Bill No"), flex: 0.111, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.invoice_number ? params?.row?.invoice_number?.length > 15 ?
                    <Tooltip placement='top' title={params?.row?.invoice_number} arrow><div>{"..." + params?.row?.invoice_number.slice(-15)}</div></Tooltip> : params?.row?.invoice_number : "-"}</Box>)
            },
            {
                field: "invoice_date", headerName: t("Bill Date"), flex: 0.111, align: "center" , headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.invoice_date ? params?.row?.invoice_date?.length > 30 ?
                    <Tooltip placement='top' title={params?.row?.invoice_date} arrow><div>{params?.row?.invoice_date.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.invoice_date : "-"}</Box>)
            },
            {
                field: "net_amount", headerName: `${t("Bill Amount")} (${CurrencySymbol})`, flex: 0.111, align: "right", headerAlign: "right",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.net_amount ? AmountFormat(params?.row?.net_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "credit_type", headerName: t("Credit type"), flex: 0.111,  align: "center",  headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.credit_type ? params?.row?.credit_type?.length > 30 ?
                    <Tooltip placement='top' title={params?.row?.credit_type} arrow><div>{params?.row?.credit_type.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.credit_type : "-"}</Box>)
            },
            {
                field: "receipt_number", headerName: t("Receipt No"), flex: 0.111, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.receipt_number ? params?.row?.receipt_number?.length > 15 ?
                    <Tooltip placement='top' title={params?.row?.receipt_number} arrow><div>{"..." + params?.row?.receipt_number.slice(-15)}</div></Tooltip> : params?.row?.receipt_number : "-"}</Box>)
            },
            {
                field: "receipt_date", headerName: t("Receipt Date"), flex: 0.111,  align: "center",  headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.receipt_date ? params?.row?.receipt_date?.length > 30 ?
                    <Tooltip placement='top' title={params?.row?.receipt_date} arrow><div>{params?.row?.receipt_date.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.receipt_date : "-"}</Box>)
            },
            {
                field: "receipt_amount", headerName: `${t("Receipt Amount")} (${CurrencySymbol})`, flex: 0.111, type: "number",
                renderCell: (params) => {
                    let amount = params.row.receipt_amount && AmountFormat(params?.row?.receipt_amount).replace(`${CurrencySymbol}`, "");
                    return (<Box component={'div'}>{amount?.length > 30 ?
                        <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                }
            }
        ]
        const disablePrintExcel = this.state.disableBtn || this.state.creditAdjustedData?.length === 0;
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("Bill Amount"), this.state.totalAmount)}
                        {AmountsCard(t("Receipt Amount"), this.state.receiptAmount)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className={this.props.fromPharmacy ? "" : 'eMed_Filter_Icon_div'}>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' disabled={disablePrintExcel} onClick={() => { this.printReports() }}>
                            <img src={disablePrintExcel ? ImagePaths.PrintIconOff.default : ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.creditAdjustedData}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(CreditSettlementPharmacyReport)